import React from "react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 lg:py-40 bg-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal className="relative">
            <div className="overflow-hidden">
              <img
                src={IMAGES.about}
                alt={IMAGES.aboutAlt}
                loading="lazy"
                decoding="async"
                width={683}
                height={1024}
                className="w-full h-[480px] lg:h-[640px] object-cover object-top grayscale-[15%] hover:grayscale-0 transition-all duration-700 hover:scale-[1.03]"
              />
            </div>
            <div className="absolute -bottom-5 -right-5 hidden md:block border border-[#C5A880] w-32 h-32 -z-0" />
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <Reveal><Overline className="mb-6">{t.about.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05] text-[#1A1A1A] mb-10">
              {t.about.title}
            </h2>
          </Reveal>
          <div className="space-y-6 max-w-2xl">
            <Reveal delay={0.15}><p className="text-[#4A4A4A] text-base sm:text-lg font-light leading-relaxed">{t.about.p1}</p></Reveal>
            <Reveal delay={0.2}><p className="text-[#4A4A4A] text-base sm:text-lg font-light leading-relaxed">{t.about.p2}</p></Reveal>
            <Reveal delay={0.25}><p className="text-[#4A4A4A] text-base sm:text-lg font-light leading-relaxed">{t.about.p3}</p></Reveal>
          </div>

          <Reveal delay={0.3}>
            <div className="grid grid-cols-3 gap-6 mt-12 pt-10 border-t border-[#1A1A1A]/10 max-w-xl">
              {t.about.stats.map((s) => (
                <div key={s.label}>
                  <div className="font-display text-4xl sm:text-5xl font-light text-[#1A1A1A]">{s.value}</div>
                  <div className="text-[11px] sm:text-xs tracking-[0.15em] uppercase text-[#7A7A7A] mt-2">{s.label}</div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
